export { default } from './BrandIcon';
